var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.weChatWarningShow)?_c('div',{staticClass:"weChat_warning"},[_c('h4',[_vm._v("请在微信或支付宝中打开")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }